export enum ReliabilityAnalyticsEventName {
  userEntersReliabilityEngineerDashboard = 'userEntersReliabilityEngineerDashboard',
  userViewsKmsWidget = 'userViewsKmsWidget'
}

export type ReliabilityAnalyticsEvent =
  | {
      name: ReliabilityAnalyticsEventName.userViewsKmsWidget
    }
  | {
      name: ReliabilityAnalyticsEventName.userEntersReliabilityEngineerDashboard
    }
